<template lang="pug">
SspLayout(area="core")
  template(slot="actions")
    router-link.btn.btn-primary(:to="{name: 'newCodeStatus'}") New Code Status
  span.error-handling {{errorMsg}}
  DataGrid(ref="grid" :fetch="fetchData" @error="$emit('error', $event)" :withoutPagination="true")
    tr(slot="thead")
      th Id
      th Description
      th Validatable
      th Packable
      th Settable
      th Unsettable
      th
    tr(v-for="cs in codeStatuses")
      td {{cs.id}}
      td {{cs.description}}
      td {{cs.validatable}}
      td {{cs.packable}}
      td {{cs.settable}}
      td {{cs.unsettable}}
      td.actions
        router-link.btn-edit(v-if="!cs.builtin" title="Edit" :to="{name: 'editCodeStatus', params: {id: cs.id}}")
</template>

<script>
import DataGrid from '@/components/ssp/DataGrid'
import Core from '@/service/apis/Core'

export default {
  data() {
    return {
      errorMsg: null,
      codeStatuses: null
    }
  },
  methods: {
    fetchData() {
      return Core.listCodeStatuses()
        .then((resp) => {
          this.codeStatuses = resp.data.codeStatusField
          return resp.data.totalRecords
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  components: {
    DataGrid
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/configuration/codestatus/CodeStatuses.vue